<template>
  <div class="card-detail">
    <mt-header fixed title="礼品卡">
      <router-link to="/inquire-app" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div style="height:45px;"></div>
    <div class="list">
      <div class="item flexsb">
        <div class="left">卡号</div>
        <div class="right">{{card_detail.card_no}}</div>
      </div>
      <div class="item flexsb">
        <div class="left">有效期</div>
        <div class="right">{{card_detail.valid_date}}</div>
      </div>
      <div class="item flexsb">
        <div class="left">CVC2</div>
        <div class="right">{{card_detail.cvc2}}</div>
      </div>
      <div class="item flexsb">
        <div class="left">余额</div>
        <div class="right">
          <span class="p-FA800A p-fw">{{card_detail.balance}}</span>
          <span style="margin-left:6px;">{{card_detail.currency}}</span>
        </div>
      </div>
      <div class="item flexsb">
        <div class="left">状态</div>
        <div class="right">{{card_detail.statusInWords}}</div>
      </div>
      <div class="item flexsb">
        <div class="left">失效时间</div>
        <div class="right">{{card_detail.invalid_date}}</div>
      </div>
    </div>
    <div class="download-box">
      <span class="p-666">可下载APP查看更多管理</span>
      <!-- <a href="https://www.globalcash.hk/download/globalCash.apk" target="_blank" class="download">点击下载APP</a> -->
      <span class="download" @click="download">点击下载APP</span>
    </div>
    <div class="activate-box flexsb" v-if="type==='entity'">
      <span>激活码后6位（登录APP）</span>
      <span>{{card_detail.activate_code}}</span>
    </div>
    <div class="activate-box flexsb" v-if="type==='virtual'">
      <span class="flexa" style="color:#999;">初始密码（登录APP）</span>
      <span style="border:1px solid #ccc;padding:4px 6px;border-radius:2px;" @click="getCode">获取密码</span>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { isAndroid } from "@/utils/mobile";
export default {
  data() {
    return {
      status: "",
      type: "",
      card_detail: {}
    };
  },
  methods: {
    download() {
      if (isAndroid) {
        window.location.href =
          "https://www.globalcash.hk/applicationManage/open/appDown.do?appid=1";
      } else {
        window.location.href = "https://itunes.apple.com/hk/app/id682185259";
      }
    },
    async getOrderStatus() {
      let res = await aPost2(api.queryStatus, {
        order_no: sessionStorage.getItem("order_no")
      });
      if (res.data.errCode === "99999") {
        this.status = res.data.retData.status;
        this.type = res.data.retData.card_type === "00" ? "entity" : "virtual";
      }
    },
    async getCode() {
      let params = {
        order_no: sessionStorage.getItem("order_no"),
        card_no: this.card_detail.card_no
      };
      // console.log(this.card_detail);
      let res = await aPost2(api.getCardPsw, params);
      if (res.data.errCode === "99999") {
        Toast(`初始密码已成功发送至預留的郵箱${res.data.retData}`);
      } else {
        Toast.fail(`${res.data.retData}`);
      }
    }
  },
  mounted() {
    if (Object.keys(this.$route.params).length == 0) {
      this.$message.error({
        message: "訂單號丟失，請重新打開此頁面！"
      });
    } else {
      this.card_detail = this.$route.params.card_detail;
      this.getOrderStatus();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-detail {
  font-size: 20px;
  background: #f6f5fa;
  height: 100%;
  /deep/ .mint-header {
    font-size: 22px;
    height: 60px;
    background: linear-gradient(to bottom, #37363b, #424244);
  }
  /deep/ .mint-header-title {
    height: 60px;
    line-height: 60px;
    font-weight: bold !important;
  }
  .list {
    background: #fff;
    border-top: 1px solid #ccc;
    margin-top: 20px;
    .item {
      padding: 20px 0;
      margin: 0 20px;
      border-bottom: 1px solid #eee;
      .left {
        color: #666;
      }
    }
  }
  .download-box {
    padding: 40px;
    .download {
      color: #4d8ff2;
      padding: 10px;
      cursor: pointer;
    }
  }
  .activate-box {
    background: #fff;
    padding: 20px;
    border-bottom: 1px solid #ccc;
  }
}
</style>